'use client';

import { useTranslations } from 'next-intl';
import { LogoMarquee } from './LogoMarquee';
import { FounderVideo } from './FounderVideo';

export function SocialProof() {
  const t = useTranslations('socialProof');

  return (
    <section className="bg-background-primary pt-20 pb-20 px-[10%] flex flex-col gap-10">

      <p className="font-mono text-eyebrow font-semibold tracking-[var(--hero-label-tracking)] uppercase text-font-navy">
        {t('eyebrow')}
      </p>

      {/* Logos */}
      <div className="flex flex-col items-center gap-6">
        <LogoMarquee />
      </div>

      {/* Video — click to play */}
      {/*<FounderVideo />*/}

    </section>
  );
}
